import * as Yup from 'yup';

import VALIDATION_MESSAGES from 'constants/validationMessages';

export const spotAllocateCodeValidationSchema = Yup.object({
  creativeId: Yup.number().required(VALIDATION_MESSAGES.REQUIRED),
  codeId: Yup.number().optional(),
});
